import React from "react";

const NoDressings = ({ label }) => {
    const { iconPath } = reactConfig;

    return (
        <div id="no-dressings">
            <img src={`${iconPath}/jar.svg`} alt="jar image" />
            <p>{label}</p>
        </div>
    );
};

export default NoDressings;
